import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import store from './store'
import titleMixin from './mixins/titleMixin'
import vuetify from './plugins/vuetify';
window.axios = require('axios');
Vue.config.productionTip = false
Vue.mixin(titleMixin)
Vue.use(VueAxios, axios)
Vue.prototype.$hostname="http://admin.agritrust.vn"
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
